const operators = [    
    {id:1, name:"<", label: "<"},
    {id:2, name:"<=", label: "<="},
    {id:3, name:">", label: ">"},
    {id:4, name:">=", label: ">="},
    {id:5, name:"=", label: "="},
    {id:6, name:"<>", label: "<>"},
    {id:7, name:"in", label: "In"},
    {id:8, name:"notIn", label: "Not In"},
    {id:9, name:"beginsWith", label: "Starts With"},    
    {id:10, name:"endsWith", label: "Ends With"},
    {id:11, name:"contains", label: "Contains"},
    {id:12, name:"between", label: "Between"},
    {id:13, name:"null", label: "Is NULL"},
    {id:14, name:"notNull", label: "Not NULL"},
];

export const getQueryOperators = (dataTypeId, isLookup) => {
    if(isLookup)
        return [operators[6], operators[7], operators[12], operators[13]];
    else if (dataTypeId == 1)//bool
        return [...operators.slice(4, 5), operators[12], operators[13]];
    else if (dataTypeId == 2)//number
        return [...operators.slice(0, 6), operators[12], operators[13]];
    else if (dataTypeId == 3)//string
        return [...operators.slice(4, 11).filter(e => e.id != 7 && e.id != 8), operators[12], operators[13]];
    else //date or datetime
        return [operators[11], ...operators.slice(0, 6), operators[12], operators[13]];
};